import {
    LIST_DEFENSORIES,
    LIST_DEFENSORIES_SUCCESS,
    LIST_DEFENSORIES_ERROR,
    ADD_DEFENSORIES,
    SAVE_DEFENSORIES,
    SAVE_DEFENSORIES_SUCCESS,
    SAVE_DEFENSORIES_ERROR,
    DELETE_DEFENSORIES,
    DELETE_DEFENSORIES_SUCCESS,
    DELETE_DEFENSORIES_ERROR,
    EDIT_DEFENSORIES,
    UPDATE_DEFENSORIES,
    UPDATE_DEFENSORIES_SUCCESS,
    UPDATE_DEFENSORIES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import defensoriesData from '../data/defensories';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'defensoria';

//LISTAR DEFENSORYS
export function listDefensoriesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listDefensories() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const defensories = response.data;
            //const defensories = defensoriesData;
            //Llamo al dispatch
            dispatch( listDefensoriesSuccess(defensories.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listDefensoriesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listDefensories = () => ({
    type: LIST_DEFENSORIES,
    payload: true
});

const listDefensoriesSuccess = defensories => ({
    type: LIST_DEFENSORIES_SUCCESS,
    payload: defensories
});

const listDefensoriesError = error => ({
    type: LIST_DEFENSORIES_ERROR,
    payload: error
});

//ADD DEFENSORY
export function addDefensoriesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addDefensories(false) );
        //Abro el formulario
        showForm();
    }
}

const addDefensories = isEdit => ({
    type: ADD_DEFENSORIES,
    payload: isEdit
});

//SAVE DEFENSORY
export function saveDefensoriesAction(defensory, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveDefensories() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, defensory);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveDefensoriesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveDefensoriesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveDefensories = () => ({
    type: SAVE_DEFENSORIES,
    payload: true
});


const saveDefensoriesSuccess = defensory => ({
    type: SAVE_DEFENSORIES_SUCCESS,
    payload: defensory
});

const saveDefensoriesError = error => ({
    type: SAVE_DEFENSORIES_ERROR,
    payload: error
});

//EDIT DEFENSORY
export function editDefensoriesAction(defensory, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editDefensories(defensory) );
        //Abro el formulario
        showForm();
    }
}

const editDefensories = defensory => ({
    type: EDIT_DEFENSORIES,
    payload: defensory
});

//UPDATE DEFENSORY
export function updateDefensoriesAction(defensory, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateDefensories() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${defensory.id}`, defensory);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateDefensoriesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateDefensoriesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateDefensories = () => ({
    type: UPDATE_DEFENSORIES,
    payload: true
});

const updateDefensoriesSuccess = defensory => ({
    type: UPDATE_DEFENSORIES_SUCCESS,
    payload: defensory
});

const updateDefensoriesError = error => ({
    type: UPDATE_DEFENSORIES_ERROR,
    payload: error
});

//DELETE DEFENSORY
export function deleteDefensoriesAction(defensory) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteDefensories() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${defensory.id}`);
            const response = await clienteAxios.put(`/${controller}/${defensory.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteDefensoriesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteDefensoriesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteDefensories = () => ({
    type: DELETE_DEFENSORIES,
    payload: true
});

const deleteDefensoriesSuccess = defensory => ({
    type: DELETE_DEFENSORIES_SUCCESS,
    payload: defensory
});

const deleteDefensoriesError = error => ({
    type: DELETE_DEFENSORIES_ERROR,
    payload: error
});